import React from 'react';
import styled from 'styled-components';

import SingleAssetContainer from './SingleAssetContainer';
import MultipleAssetsContainer from './MultipleAssetsContainer';

import NoDataMessage from '../components/common/NoDataMessage';

const MainWrapper = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 1170px;
  margin: 0px auto;

  @media only screen and (max-width: 600px){
    width: 100%;
    padding: 0px;
    margin: 0px 0px 80px 0px;
  }
`;

const MainAssetContainer = ({
  id,
  assets,
  branding,
  token,
  translate,
  showPaywall,
}) => (
  <MainWrapper>
    {assets.length === 1 ? (
      <SingleAssetContainer
        asset={assets[0]}
        branding={branding}
        token={token}
        showPaywall={showPaywall}
        translate={translate}
      >
        <NoDataMessage>
          {translate('item_id_does_not_exist', { id })}
        </NoDataMessage>
      </SingleAssetContainer>
    ) : (
      <MultipleAssetsContainer
        assets={assets}
        branding={branding}
        token={token}
        showPaywall={showPaywall}
        translate={translate}
      />
    )}
  </MainWrapper>
);

export default MainAssetContainer;